import { Heading, Spacer, Switch } from '@sparemin/blockhead';
import cn from 'classnames';
import * as React from 'react';

import { useTemplateState } from '../context/VideoTemplateStateContext';
import { captionsViewBlock as block } from '../utils';
import { useCaptionsChildViewContext } from './CaptionsChildViewContext';

export interface CaptionsChildViewContentsProps {}

const CaptionsChildViewContents: React.FC<CaptionsChildViewContentsProps> = () => {
  const {
    className,
    topSlot,
    actionsSlot,
    bottomSlot,
    switchLabel,
    onTranscriptionChange,
  } = useCaptionsChildViewContext();
  const { transcription } = useTemplateState();

  return (
    <Spacer
      space="24px"
      orientation="vertical"
      className={cn(block('contents'), className)}
    >
      {topSlot}

      <Spacer className={block('card')} orientation="vertical" space={3}>
        <Spacer
          className={block('toggle-row')}
          orientation="horizontal"
          align="center"
          justify="space-between"
        >
          <Heading level={2} className={block('text')}>
            {switchLabel}
          </Heading>

          <Switch
            isSelected={transcription?.transcribe}
            onChange={onTranscriptionChange}
          />
        </Spacer>

        {actionsSlot}
      </Spacer>

      {bottomSlot}
    </Spacer>
  );
};

export default CaptionsChildViewContents;
